import { on } from 'delegated-events'
import requestTimeout from '../common/requestTimeout'
import debounce from 'lodash/debounce'

const SELECTORS = Selectors({
  header: 'site-header',
  navTrigger: 'site-nav-trigger',
  htmlNavActive: 'js-nav-active',
})

const $header = document.querySelector(SELECTORS.asClass('header'))

const fn = {
  init: () => {
    fn.bindEvents()
  },

  bindEvents: () => {
    window.addEventListener('resize', debounce(fn.handleResize, 250))
    on('click', SELECTORS.asClass('navTrigger'), fn.toggleNav)
  },

  handleResize: () => {
    if (window.matchMedia('(min-width: 1024px)').matches) {
      document.documentElement.classList.remove(SELECTORS.htmlNavActive)
    }
  },

  toggleNav: () => {
    document.documentElement.classList.toggle(SELECTORS.htmlNavActive)

    if (!document.documentElement.classList.contains(SELECTORS.htmlNavActive)) {
      requestTimeout(() => {
        document.querySelector('.site-nav').scrollTop = 0
      }, 400)
    }
  },
}

export default {
  can: () => document.contains($header),
  run: fn.init,
}
